import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { isLogedIn, userDetails, userRole, postData } from "../../api";
import Loader from "../../components/Loader";

const REFRESH_FIELDS = ["user_completion_status", "onboard_status", "dashbaord_url"];

const LayoutCheck = ({ children }) => {
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(
        isLogedIn() && !userDetails()?.user_completion_status
    );

    useEffect(() => {
        if (!refreshing) return;
        const refreshUserDetails = async () => {
            const res = await postData("get_user_details", {}, {});
            if (res?.status === true && res?.data) {
                const updates = {};
                REFRESH_FIELDS.forEach((key) => {
                    if (res.data[key] !== undefined) updates[key] = res.data[key];
                });
                if (Object.keys(updates).length > 0) {
                    localStorage.setItem(
                        "guhroo_user_details",
                        JSON.stringify({ ...userDetails(), ...updates })
                    );
                    if (updates.onboard_status !== undefined) {
                        localStorage.setItem("guhroo_onbord_status", updates.onboard_status);
                    }
                }
            }
            setRefreshing(false);
        };
        refreshUserDetails();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (refreshing) {
        return <Loader />;
    }

    const userDetail = userDetails();

    if (!isLogedIn()) {
        localStorage.clear();
        return <Navigate to="/login" replace />;
    }
    if (userDetails()?.user_completion_status) {
        return children;
    } else {
        if (userRole() === 'Employee') {
            if (userDetail?.onboard_status !== 'completed' && userDetail?.onboard_status !== 'offer_sign') {
                navigate("/employee-onboard-sections")
            } else if (userDetail?.onboard_status === 'offer_sign') {
                navigate("/offer-letter")
            } else if (userDetail?.onboard_status === 'completed') {
                window.open(userDetails()?.dashbaord_url, "_self");
            }
        } else if (userRole() === 'Client') {
            if (userDetail?.onboard_status !== 'completed' && userDetail?.onboard_status !== 'offer_sign') {
                navigate("/client-gusto-onboard-sections")
            } else if (userDetail?.onboard_status === 'offer_sign') {
                navigate("/offer-letter")
            } else if (userDetail?.onboard_status === 'completed') {
                window.open(userDetails()?.dashbaord_url, "_self");
            }
        }
    }

}
export default LayoutCheck;